// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { EntityBaseDto } from './EntityBaseDto';

// AbilityIntranet.Data.Intranet.QbModels.QbAdditionalContactDto
export class QbAdditionalContactDto extends EntityBaseDto {
    public contactName: string = null;
    public contactValue: string = null;
    public type: string = null;
}


    



